import React, { Fragment, useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import SubscribeFormTwo from '../form/SubscribeFormTwo';
import SocialOne from '../social/SocialOne'
import CopyRightThree from './CopyRightThree'
import {
    AboutMenu,
    PlatformMenu,
    AITechMenu,
    ESGMenu,
    RecruitMenu,
    FooterContactLink,
    flattenServiceMenuForFooter,
} from '../../constants/siteMenus'

const QuickMenuColumns = [
    { title: '코담소개', links: AboutMenu },
    { title: '서비스', links: flattenServiceMenuForFooter() },
    { title: '플랫폼', links: PlatformMenu },
    { title: 'AI기술', links: AITechMenu },
    { title: 'ESG', links: ESGMenu },
    { title: '채용', links: [...RecruitMenu, FooterContactLink] },
]

const FooterThree = ({ hideNewsletter = true }) => {
    const [openMap, setOpenMap] = useState(() => ({}))

    const toggleGroup = useCallback((title) => {
        setOpenMap((prev) => ({ ...prev, [title]: !prev[title] }))
    }, [])

    return (
        <Fragment>
            <footer className="footer-area theme-footer-three pt-145 pt-lg-100 pt-sm-100">
                <img className="footer-shape shape-1b" src="/assets/img/shape/star-3b.svg" alt="배경 도형"/>
                <img className="footer-shape shape-2b" src="/assets/img/shape/star-4b.svg" alt="배경 도형"/>
                <img className="footer-shape shape-3b" src="/assets/img/shape/star-6b.svg" alt="배경 도형"/>
                <img className="footer-shape shape-4b" src="/assets/img/shape/star-5b.svg" alt="배경 도형"/>
                <img className="footer-shape shape-5b" src="/assets/img/shape/star-5b.svg" alt="배경 도형"/>
                <img className="fot-shape-one" src="/assets/img/shape/line-round-7b.svg" alt="푸터 배경"/>
                <div className="container">
                    <div className="row gx-4 gx-xxl-5 mb-10">
                        <div className="col-xxl-3 col-md-4" data-aos="fade-up">
                            <div className="footer__widget mb-40">
                                <Link to="/" aria-label="CODAM 홈">
                                    <img
                                        src="/assets/img/logo/codam-logo.svg"
                                        alt="CODAM 로고"
                                        style={{ maxHeight: '42px', width: 'auto' }}
                                    />
                                </Link>
                                <p className="text-white mt-20" style={{fontSize:'13px', lineHeight:'1.8', opacity:'0.75'}}>
                                    한국 기업의 디지털 경쟁력을 높이는 프리미엄 엔터프라이즈 IT 솔루션 파트너.
                                    웹 플랫폼, AI 시스템, 클라우드 인프라, 사이버 보안까지 함께합니다.
                                </p>
                                <div className="mt-20">
                                    <SocialOne />
                                </div>
                            </div>
                        </div>
                        <div className={hideNewsletter ? 'col-xxl-9 col-xl-9 col-lg-8' : 'col-xxl-6 col-xl-6 col-lg-8'} data-aos="fade-up" data-aos-delay={100}>
                            <div className="footer__widget mb-40">
                                <div className="row codam-footer-sitemap">
                                    {QuickMenuColumns.map((group, index) => {
                                        const isOpen = !!openMap[group.title]
                                        const headingId = `footer-sitemap-h-${index}`
                                        const panelId = `footer-sitemap-p-${index}`
                                        return (
                                            <div key={group.title} className="col-12 col-sm-6 col-md-4 col-lg-4 mb-0">
                                                <button
                                                    type="button"
                                                    id={headingId}
                                                    className="codam-footer-sitemap__toggle"
                                                    aria-expanded={isOpen}
                                                    aria-controls={panelId}
                                                    onClick={() => toggleGroup(group.title)}
                                                >
                                                    <span>{group.title}</span>
                                                    <i
                                                        className="bi bi-chevron-down codam-footer-sitemap__chevron"
                                                        aria-hidden="true"
                                                    />
                                                </button>
                                                <div
                                                    id={panelId}
                                                    role="region"
                                                    aria-labelledby={headingId}
                                                    className={`codam-footer-sitemap__panel${isOpen ? ' is-open' : ''}`}
                                                >
                                                    <div className="codam-footer-sitemap__panel-inner">
                                                        <ul className="list-none codam-footer-sitemap__list mb-0">
                                                            {group.links.map((link) => (
                                                                <li key={`${group.title}-${link.name}-${link.routerPath}`}>
                                                                    <Link to={link.routerPath}>{link.name}</Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        {!hideNewsletter && (
                            <div className="col-xxl-3 col-xl-4 col-md-6" data-aos="fade-up" data-aos-delay={200}>
                                <div className="footer__widget mb-40">
                                    <h4 className="widget-title">뉴스레터 구독</h4>
                                    <p className="fs-17 text-white mb-0 pb-20">IT 구축 트렌드와 기술 인사이트를 받아보세요.</p>
                                    <SubscribeFormTwo />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <CopyRightThree />
            </footer>
        </Fragment>
    )
}

export default FooterThree
